import axios from 'axios'
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'master',
    state: {
        master: []
    },
    getters: {
        getMaster: state => {
            return state.master
        }
    },
    mutations: {
        MASTER: (state, payload) => {
            state.master = payload
        },
    },
    actions: {
        FETCH_MASTER(store) {
            return axios({
                method: 'get',
                url: ServiceURL + 'master_karyawan/master',
                auth: {
                    username: store.rootState.auth.auth.username,
                    password: store.rootState.auth.auth.password
                },
                headers: {
                    'X-API-KEY': store.rootState.auth.auth.apikey
                }
            }).then(response => {
                store.commit('MASTER', response.data)
            }).catch(err => {
                return err
            })
        }
    }
}
